<template>
  <div>
    The orbital average power for propulsion represents how much
                    power a spacecraft can allocate to its propulsion system in
                    average over one orbital period.
                    <br />
                    The orbital average power depends on the solar arrays, the
                    attitude mode and the orbit. It can be estimated in the
                    simulation mission <i>Maneuvering Strategy Design</i>.
                    <br />
                    <br />
                    For instance, if the propulsion system you plan to use with
                    your spacecraft has a nominal power of 100 W and your
                    spacecraft can only deliver 50 W per orbit on average, the
                    maximum mean duty cycle achievable for any mission longer
                    than a few orbital periods will be 50 %. This means that the
                    propulsion system will be thrusting (on average) at most 50
                    % of the time.
                    <br />
                    <br />
                    The orbital average power must be enough to supply the
                    thruster burn, as well as its warm-up and its stand-by
                    state.
                    <br />
                    <br />
                    <div class="text-xs-center">
                      <katex-element
                        expression="P_\mathrm{OA} = \xi_\mathrm{max} P_\mathrm{th} + \xi_\mathrm{WU} P_\mathrm{WU} + (1 - \xi_\mathrm{max} - \xi_\mathrm{WU}) P_\mathrm{SB}"
                      />
                    </div>
                    where
                    <ul>
                      <li>
                        <katex-element expression="P_\mathrm{OA}" /> is the
                        orbital average power;
                      </li>
                      <li>
                        <katex-element expression="P_\mathrm{th}" /> is the
                        propulsion system thrust power;
                      </li>
                      <li>
                        <katex-element expression="P_\mathrm{WU}" /> is the
                        propulsion system warm-up power;
                      </li>
                      <li>
                        <katex-element expression="P_\mathrm{SB}" /> is the
                        propulsion system stand-by power;
                      </li>
                      <li>
                        <katex-element expression="\xi_\mathrm{max}" /> is the
                        maximum percentage of time the propulsion system may
                        thrust with the conditions provided;
                      </li>
                      <li>
                        <katex-element expression="\xi_\mathrm{WU}" /> is the
                        percentage of time the propulsion system is warming up.
                      </li>
                    </ul>
                    <br />
                    The thruster warm-up average duty cycle depends on the ratio
                    between the warm-up duration in a manoeuvre cycle
                    <katex-element expression="\Delta t_\mathrm{WU}" /> and the
                    orbital Keplerian period
                    <katex-element expression="T_\mathrm{K}" />:
                    <br />
                    <br />
                    <div class="text-xs-center">
                      <katex-element
                        expression="{\xi}_\mathrm{WU} = \dfrac{\Delta t_\mathrm{WU}}{N \cdot T_\mathrm{K}}"
                      />
                    </div>
                    <br />
                    <br />
                    where <katex-element expression="N" /> is the number of
                    orbits in a manoeuvre cycle. For its calculation
                    <katex-element expression="T_\mathrm{K}" /> is considered to
                    be constant and equal to the period of the initial orbit of
                    the mission.
  </div>
</template>

<script>
export default {
  name: 'tooltipOnBoardAveragePower'
}
</script>
